<template>
  <a :class="$data.class" :href="link" :target="external ? '_blank' : null" v-analytics="analytics">{{label}}</a>
</template>

<script>
import analytics from '../../../directives/analytics';

export default {
  name      : 'side-menu-item',
  directives: {
    analytics,
  },
  props: {
    active: {
      type   : Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      label    : null,
      link     : null,
      external : null,
      analytics: null,
    };
  },
};
</script>
